import { render } from "./ViewImo5Component.vue?vue&type=template&id=7b5c21d5&lang=true"
import script from "./ViewImo5Component.vue?vue&type=script&lang=js"
export * from "./ViewImo5Component.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__